import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const DialogWIthError = ({ isOpen, handleClose }) => {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Uwaga</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Twoje dane personalne są nieprawidłowe. Aby oddać głos, skontaktuj się
          z{' '}
          <Link href='https://decyduje.lublin.eu/pl/budzet-obywatelski-l/kontakt/'>
            Biurem Partycypacji Społecznej
          </Link>
          .
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Zamknij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogWIthError.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DialogWIthError;
